import { Time } from '@angular/common';
import { Deserializable } from './deserializable.model';
import { Host } from './host.model';
import { Schedule } from './schedule.model';
import { Social } from './social.model';
import { Image } from './image.model';
import { Day } from './day.enum'

export class Show implements Deserializable {
   public id: number;
   public title: string;
   public description: string;
   public hosts: Host[];
   public schedules: Schedule[];
   public link: string;
   public social: Social;
   public image: Image;

   deserialize(input: any): this {
      Object.assign(this, input);

      this.hosts = input.hosts.map(h => new Host().deserialize(h));
      this.schedules = input.schedules.map(s => new Schedule().deserialize(s));
      this.social = new Social().deserialize(input.social);
      this.image = new Image().deserialize(input.image);

      return this;
   }

   broadcastsOnDay(day: Day): boolean {
      let ret = false;
      this.schedules.forEach(s => {
         s.days.forEach(d => {
            if (d.asNumber === day.asNumber) {
               ret = true;
            }
         });
      });
      return ret;
   }

   schedulesForDay(day: Day): Schedule[] {
      const ret = [];
      this.schedules.forEach(s => {
         s.days.forEach(d => {
            if (d.asNumber === day.asNumber) {
               ret.push(s);
            }
         });
      });
      return ret;
   }


   private timeIsInSchedule(time: Time, schedule: Schedule): boolean {
      const t = new Date();
      const start = new Date();
      const end = new Date();

      t.setHours(time.hours, time.minutes);
      start.setHours(schedule.start.hours, schedule.start.minutes);
      end.setHours(schedule.end.hours, schedule.end.minutes);
      return (start <= t) && (t < end);
   }

   broadcastsNow(): boolean {
      const now = new Date(new Date().toLocaleString('en-US', {timeZone: 'America/Buenos_Aires'}));
      const nowTime: Time = {hours: now.getHours(), minutes: now.getMinutes()};
      const today = new Day().deserialize(now.getDay());
      let ret = false;

      this.schedules.forEach(s => {
         if (this.timeIsInSchedule(nowTime, s)) {
            s.days.forEach(d => {
               if (d.asNumber === today.asNumber) {
                  ret = true;
               }
            });
         }
      });
      return ret;
   }
}
